import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IKBCatalogCategory, IKBCatalogSelection, IWorkerConfiguration } from '../interfaces/base-knowledge-catalog';
import {IAiResponse } from '../interfaces/ai-bpm-knowledge-base';

@Injectable({
  providedIn: 'root'
})
export class AIForProcessesService {
  AIForProcesses = 'api/AIForProcesses';
  constructor(private _aiForProcessesHttp: RestApi) { }

  getApplications(): Observable<any> {
    return this._aiForProcessesHttp.get(`${this.AIForProcesses}/applications`);
  }

  getKnowledgebases(): Observable<IKBCatalogCategory[]> {
    return this._aiForProcessesHttp.get(`${this.AIForProcesses}/knowledge-bases`);
  }

  getSelectedItem(idItem: string): Observable<IAiResponse> {
    return this._aiForProcessesHttp.get(`${this.AIForProcesses}/selected/${idItem}`);
  }

  saveAIWorkerConfiguration(idItem: string, config: IWorkerConfiguration): Observable<IWorkerConfiguration> {
    return this._aiForProcessesHttp.post(`${this.AIForProcesses}/saveAIWorkerConfiguration/${idItem}`, config);
  }

  resetAIWorkerConfiguration(idItem: string): Observable<IWorkerConfiguration> {
    return this._aiForProcessesHttp.post(`${this.AIForProcesses}/resetAIWorkerConfiguration/${idItem}`, {});
  }

  saveAIBpmKnowledgeBaseEnvironment(kBCatalogSelection: IKBCatalogSelection): Observable<IWorkerConfiguration> {
    return this._aiForProcessesHttp.post(`${this.AIForProcesses}/saveAIBpmKnowledgeBaseEnvironment`, kBCatalogSelection);
  }

  removeAIBpmKnowledgeBaseEnvironmentItem(kBCatalogSelection: IKBCatalogSelection): Observable<IWorkerConfiguration> {
    return this._aiForProcessesHttp.post(`${this.AIForProcesses}/removeAIBpmKnowledgeBaseEnvironmentItem`, kBCatalogSelection);
  }
}
